import React from 'react'

const sizeClassName = {
  prose: 'max-w-prose',
  sm: 'max-w-screen-sm',
  md: 'max-w-screen-md',
  lg: 'max-w-screen-lg',
  xl: 'max-w-screen-xl',
  '2xl': 'max-w-screen-2xl'
}

const Container = ({ children, size = 'xl', noPadding }) => {
  return (
    <div
      className={`${sizeClassName[size]} mx-auto ${
        noPadding ? '' : 'px-4 md:px-6 lg:px-8'
      }`}
    >
      {children}
    </div>
  )
}

export default Container
